<template>
    <v-dialog
        v-model="dialog"
        max-width="400"
    >
        <template #activator="{ on }">
            <div class="text-right mb-4">
                <v-btn
                    v-on="on"
                    color="primary"
                    rounded
                >
                    Ambil soal
                </v-btn>
            </div>
        </template>

        <v-card>
            <v-card-title>Ambil soal dari bank soal</v-card-title>

            <v-card-text>
                <form>
                    <v-autocomplete
                        v-model="selectedQuestionBank"
                        :items="questionbanks"
                        label="Bank soal"
                        :loading="questionbanks.length === 0"
                    ></v-autocomplete>

                    <v-autocomplete
                        v-if="!!selectedQuestionBank"
                        v-model="selectedLabel"
                        :items="labels"
                        label="Label"
                        :loading="labels.length === 0"
                    ></v-autocomplete>
                </form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    @click="dialog = false"
                    text
                >
                    Batal
                </v-btn>
                <v-btn
                    @click="appendQuestions"
                    text
                    color="primary"
                    :disabled="!selectedLabel"
                    :loading="$store.get('loader/loading', 'appending')"
                >
                    Ambil
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            questionbanks: [],
            selectedQuestionBank: null,
            labels: [],
            selectedLabel: null,
        }
    },

    watch: {
        selectedQuestionBank() {
            if (this.selectedQuestionBank) {
                this.labels = []
                this.selectedLabel = null

                this.$api
                    .get(`questionbank/${this.selectedQuestionBank}/label`)
                    .then((response) => {
                        this.labels = response.data.labels
                    })
            }
        },
    },

    methods: {
        appendQuestions() {
            this.$api
                .get(
                    `questionbank/${this.selectedQuestionBank}/${this.selectedLabel}/question`,
                    { loader: 'appending' }
                )
                .then((response) => {
                    this.$store.dispatch(
                        'createtryout/appendQuestions',
                        response.data.questions
                    )

                    this.dialog = false
                })
        },
    },

    created() {
        this.$api.get('questionbank').then((response) => {
            this.questionbanks = response.data.questionbanks.map((e) => {
                return {
                    text: e.title,
                    value: e.id,
                }
            })
        })
    },
}
</script>
